/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";

// User count data
export const COUNTS = "COUNTS";
export const COUNTS_SUCCESS = "COUNTS_SUCCESS";
export const COUNTS_FAIL = "COUNTS_FAIL";

// Recent Quotes
export const GET_RECENT_QUOTES = "GET_RECENT_QUOTES";
export const GET_RECENT_QUOTES_FAIL = "GET_RECENT_QUOTES_FAIL";
export const GET_RECENT_QUOTES_SUCCESS = "GET_RECENT_QUOTES_SUCCESS";

//pie chart
export const GET_PIE_CHART = "GET_PIE_CHART";
export const GET_PIE_CHART_FAIL = "GET_PIE_CHART_FAIL";
export const GET_PIE_CHART_SUCCESS = "GET_PIE_CHART_SUCCESS";

//bar chart
export const GET_BAR_CHART = "GET_BAR_CHART";
export const GET_BAR_CHART_FAIL = "GET_BAR_CHART_FAIL";
export const GET_BAR_CHART_SUCCESS = "GET_BAR_CHART_SUCCESS";